import { instance } from "libs/api";

import { ApiRoutesDeliveryPriority } from "../../constants";
import { DeliveryPriorityItem } from "../../deliveryPriority.types";

export const requestDeliveryPriority = async (): Promise<
  DeliveryPriorityItem[]
> => {
  return await instance.get(ApiRoutesDeliveryPriority.DeliveryPriority);
};
